// src/components/news/NewsCard.jsx
import React from "react";

function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";

  // ✅ data + hora (sem segundos), no device do usuário
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Chips determinísticos (sem IA/editorial). Baseado só no título.
function chipsFromTitle(title) {
  const t = String(title || "").toLowerCase();

  const chips = [];
  const add = (label) => {
    if (!chips.includes(label)) chips.push(label);
  };

  // B3 / ações
  if (/\bibovespa\b|\bb3\b|\bbolsa\b|\baç(ões|ao)\b|\bíndice\b/.test(t)) add("B3");

  // Câmbio (USD/BRL)
  if (/\bdólar\b|\bdolar\b|\bcâmbio\b|\busd\b|\bdólar\/real\b|\busd\/brl\b/.test(t))
    add("Câmbio");

  // Juros
  if (/\bselic\b|\bcopom\b|\bjuros\b|\bdi\b|\bcurva\b|\bfuturo(s)?\b/.test(t))
    add("Juros");

  // Inflação
  if (/\binflaç(ão|ao)\b|\bipca\b|\bigp-?m\b|\bpreços\b/.test(t)) add("Inflação");

  // BC / Fiscal (opcional, mas dá cara Brasil)
  if (/\bbanco central\b|\bbacen\b/.test(t)) add("BC");
  if (/\bfiscal\b|\barrecadaç(ão|ao)\b|\bgastos\b|\bdéficit\b|\bdeficit\b/.test(t))
    add("Fiscal");

  // Resultados / dividendos
  if (
    /\bresultado(s)?\b|\bbalanço\b|\bbalanco\b|\blucro\b|\breceita\b|\bebitda\b|\bguidance\b/.test(t)
  )
    add("Resultados");

  if (
    /\bdividendo(s)?\b|\bprovento(s)?\b|\bjcp\b|\bjuros sobre capital\b/.test(t)
  )
    add("Dividendos");

  // Commodities
  if (/\bpetróleo\b|\bpetroleo\b|\bbrent\b|\bwti\b/.test(t)) add("Petróleo");
  if (/\bminério\b|\bminerio\b|\biron ore\b/.test(t)) add("Minério");
  if (/\bsoja\b|\bsoy\b/.test(t)) add("Soja");
  if (/\bmilho\b|\bcorn\b/.test(t)) add("Milho");
  if (/\bcafé\b|\bcafe\b|\bcoffee\b/.test(t)) add("Café");
  if (/\baçúcar\b|\bacucar\b|\bsugar\b/.test(t)) add("Açúcar");

  // Limita para não poluir UI
  return chips.slice(0, 3);
}

export default function NewsCard({ item }) {
  const url = item?.url;
  const title = item?.title || "—";
  const source = item?.source || "—";
  const publishedAt = item?.publishedAt || null;
  const imageUrl = item?.imageUrl || null;

  const chips = chipsFromTitle(title);

  return (
    <a className="news-card" href={url} target="_blank" rel="noopener noreferrer">
      {imageUrl ? <img src={imageUrl} alt="" className="news-thumb" /> : null}

      <div className="news-content">
        <div className="news-title">{title}</div>

        {chips.length > 0 ? (
          <div className="news-chips">
            {chips.map((c) => (
              <span key={c} className="chip">
                {c}
              </span>
            ))}
          </div>
        ) : null}

        <div className="news-meta">
          <span>{source}</span>
          <span>·</span>
          <span>{fmtDateTime(publishedAt)}</span>
        </div>
      </div>
    </a>
  );
}
